import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { updateCustomBullets } from "./swiperPagination";
class Video {
  constructor() {
    document.querySelectorAll('.video').forEach(video => {
      const button = video.querySelector<HTMLButtonElement>('.video__play');
      const player = video.querySelector<HTMLElement>('.video__player');
      const iframe = video.querySelector<HTMLIFrameElement>('.video__iframe');

      if (!button || !player || !iframe) return;

      button.addEventListener('click', () => {
        const url = button.dataset.youtube;
        if (!url) return;

        const id = this.getYoutubeId(url);
        if (!id) return;

        iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1`;
        player.hidden = false;
        button.hidden = true;
      });
    });
  }

  getYoutubeId(url: string): string | null {
    const m = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
    return m ? m[1] : null;
  }
}

class ArticlesSlider {
  swiperElement: HTMLElement;
  swiperInstance: Swiper | null;

  constructor(swiperElement: HTMLElement) {
    this.swiperElement = swiperElement;
    this.swiperInstance = null;

    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [Pagination],

      slidesPerView: 1,
      spaceBetween: 20,

      pagination: {
        el: this.swiperElement.querySelector(".swiper-pagination") as HTMLElement,
        clickable: true,
        dynamicBullets: false,
      },

      breakpoints: {
        992: {
          enabled: false, // disables swiper on desktop
        },
      },

      on: {
        init: (swiperInstance) => updateCustomBullets(swiperInstance),
        slideChange: (swiperInstance) => updateCustomBullets(swiperInstance),
        paginationUpdate: (swiperInstance) => updateCustomBullets(swiperInstance),
      }
    });

    requestAnimationFrame(() => {
      this.swiperInstance?.update();
    });
  }
}

document
  .querySelectorAll<HTMLElement>(".swiper__videos")
  .forEach((el) => {
    new ArticlesSlider(el);
  });

export const video = new Video();
